// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cross-icon-container[data-v-01f0e59a]{display:flex;justify-content:center;margin-top:20px}.error-icon[data-v-01f0e59a]{color:#a00!important;font-size:80px!important;margin-top:-10px}.error-messages[data-v-01f0e59a]{margin-top:10px;text-align:center}.error-card-text[data-v-01f0e59a]{padding-bottom:40px!important;padding-top:40px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
